module.exports = __webpack_public_path__ + "img/9.59918c3f.jpg";